import { MenuOptions } from '@/includes/types/MenuOptions.types'

export type MenuOptionsState = {
    menuOptions: MenuOptions | null
}

export const menuOptionsState: MenuOptionsState = {
    menuOptions: null
}
